var aspiraFontStr = '"Aspira Webfont", "Helvetica", "Arial", sans-serif';
export default {
  aspira: aspiraFontStr,
  "default": aspiraFontStr
};